import { getEndpoint, getAll } from './openapi-to-har.js';
import { HTTPSnippet, availableTargets } from '@sctg/httpsnippet';
export const getEndpointSnippets = function (openApi, path, method, targets, values) {
    if (typeof values === 'undefined') {
        values = {};
    }
    const hars = getEndpoint(openApi, path, method, values);
    const snippets = [];
    for (const har of hars) {
        const harForSnippet = {
            ...har,
            postData: har.postData || { mimeType: '', text: '' }
        };
        const snippet = new HTTPSnippet(harForSnippet);
        snippets.push(...getSnippetsForTargets(targets, snippet, har.comment ? har.comment : undefined));
    }
    return {
        method: hars[0].method,
        url: hars[0].url,
        description: hars[0].description,
        resource: getResourceName(hars[0].url),
        snippets: snippets,
    };
};
export const getSnippets = function (openApi, targets) {
    const endpointHarInfoList = getAll(openApi);
    const results = [];
    for (let i in endpointHarInfoList) {
        const harInfo = endpointHarInfoList[i];
        const snippets = [];
        for (const har of harInfo.hars) {
            const harForSnippet = {
                ...har,
                postData: har.postData || { mimeType: '', text: '' }
            };
            const snippet = new HTTPSnippet(harForSnippet);
            snippets.push(...getSnippetsForTargets(targets, snippet, har.comment));
        }
        results.push({
            method: harInfo.method,
            url: harInfo.url,
            description: harInfo.description,
            resource: getResourceName(harInfo.url),
            snippets,
        });
    }
    results.sort((a, b) => {
        if (a.resource < b.resource) {
            return -1;
        }
        else if (a.resource > b.resource) {
            return 1;
        }
        else {
            return getMethodOrder(a.method.toLowerCase(), b.method.toLowerCase());
        }
    });
    return results;
};
const getMethodOrder = function (a, b) {
    const order = ['get', 'post', 'put', 'delete', 'patch'];
    if (order.indexOf(a) === -1) {
        return 1;
    }
    else if (order.indexOf(b) === -1) {
        return -1;
    }
    else if (order.indexOf(a) < order.indexOf(b)) {
        return -1;
    }
    else if (order.indexOf(a) > order.indexOf(b)) {
        return 1;
    }
    else {
        return 0;
    }
};
const getResourceName = function (urlStr) {
    const pathComponents = urlStr.split('/');
    for (let i = pathComponents.length - 1; i >= 0; i--) {
        const cand = pathComponents[i];
        if (cand !== '' && !/^{/.test(cand)) {
            return cand;
        }
    }
};
const formatTarget = function (targetStr) {
    const language = targetStr.split('_')[0];
    const title = capitalizeFirstLetter(language);
    let library = targetStr.split('_')[1];
    const validTargets = availableTargets();
    let validLanguage = false;
    let validLibrary = false;
    for (let i in validTargets) {
        const target = validTargets[i];
        if (language === target.key) {
            validLanguage = true;
            if (typeof library === 'undefined') {
                library = target.default;
                validLibrary = true;
            }
            else {
                for (let j in target.clients) {
                    const client = target.clients[j];
                    if (library === client.key) {
                        validLibrary = true;
                        break;
                    }
                }
            }
        }
    }
    if (!validLanguage || !validLibrary) {
        return null;
    }
    return {
        title: typeof library !== 'undefined'
            ? title + ' + ' + capitalizeFirstLetter(library)
            : title,
        language,
        library,
    };
};
export const getSnippetsForTargets = function (targets, snippet, mimeType) {
    const snippets = [];
    let convertOptions = {};
    for (let j in targets) {
        const target = formatTarget(targets[j]);
        if (!target)
            throw new Error('Invalid target: ' + targets[j]);
        if (target.title === 'Shell + Curl') {
            convertOptions['short'] = true;
        }
        else {
            convertOptions = {};
        }
        const convertResult = snippet.convert(target.language, typeof target.library !== 'undefined' ? target.library : undefined, convertOptions);
        const content = typeof convertResult === 'string' ? convertResult : (typeof convertResult === 'object' && convertResult ? JSON.stringify(convertResult) : '');
        snippets.push({
            id: targets[j],
            ...(mimeType !== undefined && { mimeType: mimeType }),
            title: target.title,
            content: content,
        });
    }
    return snippets;
};
const capitalizeFirstLetter = function (string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
};
export const OpenAPISnippets = {
    getSnippets,
    getEndpointSnippets,
};
if (typeof window !== 'undefined') {
    window.OpenAPISnippets = OpenAPISnippets;
}
